import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faSpinner } from '@fortawesome/free-solid-svg-icons';
import useApiFetch from '../../ApiFetch';
import { NumericFormat, PatternFormat } from 'react-number-format';
import useSignIn from 'react-auth-kit/hooks/useSignIn';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

function ProfileInfo(props) {
    const apiFetch = useApiFetch();
    const signIn = useSignIn();
    const authUser = useAuthUser();
    const authHeader = useAuthHeader();

    const [profileInfo, setProfileInfo] = useState({ firstName: '', lastName: '' });
    const [savingProfileInfo, setSavingProfileInfo] = useState(false);
    const [profileInfoSaveResult, setProfileInfoSaveResult] = useState(null);

    useEffect(() => {
        if (props.profileInfo) {
            setProfileInfo(props.profileInfo);
        }
    }, [props]);

    const saveProfileInfo = async (e) => {
        e.preventDefault();
        setSavingProfileInfo(true);

        await apiFetch.post('/api/user/userinfo', profileInfo)
            .then((resp) => {
                setProfileInfoSaveResult('Success');
                setTimeout(() => { setProfileInfoSaveResult(null); }, 5000);


                if (authUser) {
                    const token = authHeader?.split(' ')[1]; // raw JWT
                    signIn({
                        auth: {
                            token: token,
                            type: 'Bearer'
                        },
                        userState: { user: { ...authUser.user, ...profileInfo } }
                    });


                //    signIn({
                //        token: currentAuth.token,
                //        expiresIn: currentAuth.expiresIn,
                //        tokenType: currentAuth.tokenType,
                //        authState: {
                //            ...currentAuth.authState,
                //            ...newUserData, // override fields as needed
                //        },
                //    });
                }

                if (props.saved)
                    props.saved(resp.data);
            })
            .catch((ex) => {
                setProfileInfoSaveResult('Fail');
                setTimeout(() => { setProfileInfoSaveResult(null); }, 5000);
                setProfileInfo({
                    firstName: props.profileInfo.firstName,
                    lastName: props.profileInfo.lastName,
                    company: props.profileInfo.company,
                    phone: props.profileInfo.phone,
                });
            })
            .finally(() => {
                setSavingProfileInfo(false);
            });
    };
    const handlePatternFormatChange = (values, sourceInfo) => {
        if (sourceInfo.source !== 'event') {
            return;
        }
        setProfileInfo({ ...profileInfo, [sourceInfo.event.target.name]: values.value })
    };

    return (
        <form onSubmit={saveProfileInfo} className="card">
            <div className="card-header">
                Personal Info
            </div>
            <div className="card-body">
                <div className="row g-3">
                    <div className="col-sm-6">
                        <label htmlFor="firstName" className="form-label">First Name</label>
                        <input type="text" className={`form-control ${(profileInfo.firstName ?? '') !== '' ? 'is-valid' : 'is-invalid'}`} id="firstName" onChange={(e) => setProfileInfo({ ...profileInfo, [e.target.name]: e.target.value })} name="firstName" value={profileInfo.firstName ?? ''} />
                    </div>
                    <div className="col-sm-6">
                        <label htmlFor="lastName" className="form-label">Last Name</label>
                        <input type="text" className={`form-control ${(profileInfo.lastName ?? '') !== '' ? 'is-valid' : 'is-invalid'}`} id="lastName" onChange={(e) => setProfileInfo({ ...profileInfo, [e.target.name]: e.target.value })} name="lastName" value={profileInfo.lastName ?? ''} />
                    </div>
                </div>
                <div className="row g-3 mt-0">
                    <div className="col-sm-6">
                        <label htmlFor="company" className="form-label">Company</label>
                        <input type="text" className={`form-control`} id="company" onChange={(e) => setProfileInfo({ ...profileInfo, [e.target.name]: e.target.value })} name="company" value={profileInfo.company ?? ''} />
                    </div>
                    <div className="col-sm-6">
                        <label htmlFor="phone" className="form-label">Phone</label>
                        <PatternFormat name="phone" onValueChange={handlePatternFormatChange} className="form-control" id="phone" format="+1 (###) ###-####" value={profileInfo.phone} valueIsNumericString={true} allowEmptyFormatting mask="_" />
                    </div>
                </div>
            </div>
            <div className="card-footer text-body-secondary text-end">
                <button type="submit" className="btn btn-secondary btn-sm position-relative" disabled={(profileInfo.firstName ?? '') === '' || (profileInfo.lastName ?? '') === ''}>
                    <FontAwesomeIcon icon={savingProfileInfo ? faSpinner : faFloppyDisk} spin={savingProfileInfo} className="me-2" />
                    Save
                    {profileInfoSaveResult
                        ?
                        <span className={`position-absolute top-0 start-100 translate-middle p-2 border border-light rounded-circle ${profileInfoSaveResult === 'Success' ? "bg-success" : profileInfoSaveResult === 'Fail' ? "bg-danger" : ""}`}>
                            <span className="visually-hidden">Saved</span>
                        </span>
                        : null
                    }
                </button>
            </div>
        </form>
    );

}
export default ProfileInfo;
